import employeesService from '@/services/employees.service'

export default {
  namespaced: true,
  state: {
    employees: [],
    pagination: {
      current_page: 1,
      last_page: 1,
      per_page: 15,
      total: 0
    },
    loading: false,
    error: null
  },
  mutations: {
    SET_EMPLOYEES(state, employees) {
      state.employees = employees
    },
    SET_PAGINATION(state, pagination) {
      state.pagination = {
        current_page: pagination.current_page || 1,
        last_page: pagination.last_page || 1,
        per_page: pagination.per_page || 15,
        total: pagination.total || 0
      }
    },
    ADD_EMPLOYEE(state, employee) {
      state.employees.push(employee)
    },
    UPDATE_EMPLOYEE(state, updatedEmployee) {
      const index = state.employees.findIndex(e => e.id === updatedEmployee.id)
      if (index !== -1) {
        state.employees.splice(index, 1, updatedEmployee)
      }
    },
    REMOVE_EMPLOYEE(state, id) {
      state.employees = state.employees.filter(e => e.id !== id)
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async fetchEmployees({ commit }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employeesService.getAll()
        
        // Handle paginated response structure
        // The service returns: { success, message, data: { current_page, data: [...] } }
        const paginationData = response.data || {}
        const employees = paginationData.data || []
        
        commit('SET_EMPLOYEES', employees)
        commit('SET_PAGINATION', {
          current_page: paginationData.current_page,
          last_page: paginationData.last_page,
          per_page: paginationData.per_page,
          total: paginationData.total
        })
      } catch (error) {
        console.error('Error fetching employees:', error)
        commit('SET_ERROR', error.response?.data?.message || error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async createEmployee({ commit }, employeeData) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employeesService.create(employeeData)
        if (response.success) {
          commit('ADD_EMPLOYEE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async updateEmployee({ commit }, { id, employeeData }) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employeesService.update(id, employeeData)
        if (response.success) {
          commit('UPDATE_EMPLOYEE', response.data)
          return { success: true, data: response.data }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async deleteEmployee({ commit }, id) {
      try {
        commit('SET_LOADING', true)
        commit('SET_ERROR', null)
        const response = await employeesService.delete(id)
        if (response.success) {
          commit('REMOVE_EMPLOYEE', id)
          return { success: true }
        }
        throw new Error(response.message)
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message
        commit('SET_ERROR', errorMessage)
        return { success: false, error: errorMessage }
      } finally {
        commit('SET_LOADING', false)
      }
    }
  },
  getters: {
    allEmployees: state => state.employees,
    activeEmployees: state => state.employees.filter(e => e.active),
    isLoading: state => state.loading,
    pagination: state => state.pagination
  }
} 